function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import tokens from '@mineral/tokens/build/light/index.json';
export var typography = _extends({}, tokens.typography, {
  fontSize: parseInt(tokens.typography.fontSize),
  htmlFontSize: parseInt(tokens.typography.htmlFontSize),
  button: _extends({}, tokens.typography.button, {
    textTransform: 'none' // Specified here to avoid TS error

  })
});